App.SmRadioButtonComponent = Em.Component.extend
  tagName: 'label'
  classNames: [ 'sm-radio-button' ]

  classNameBindings: [ 'isChecked:-checked' ]

  valueBinding: 'parentView.value'
  option: null

  isChecked: (->
    @get('value') is @get('option')
  ).property('value', 'option')

  actions:
    select: ->
      @set('value', @get('option'))

      changeAction = @get('parentView.onChange')
      if changeAction
        @send( changeAction, @get('value'))


